import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchCustomers } from '../actions/customers';
import { fetchMachines } from '../actions/machines';
import { fetchLockerQty } from '../actions/objectives';
import { renderSelectField } from '../utils/forms';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import LoadingProgress from '../components/LoadingProgress';

class LockerQtyFilterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loaded: false };
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const { role, fetchCustomers, fetchMachines } = this.props;
    if (role === 'ADMIN') {
      fetchCustomers();
    }
    fetchMachines();
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { machines, customers, role } = props;
    if (!this.state.loaded && machines && (role !== 'ADMIN' || customers)) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {
    const { role, customerId } = this.props;
    const customer = role === 'ADMIN' ? props.Customer : customerId;

    if (role === 'ADMIN' && !customer) {
      throw new SubmissionError({ _error: 'El cliente es obligatorio.' });
    }

    if (!props.Year) {
      throw new SubmissionError({ _error: 'El año es obligatorio.' });
    }

    return this.props.fetchLockerQty(customer, props.Year, props.Machine);
  }

  render() {
    const { handleSubmit, customers, machines, formValues, error, submitting, role } = this.props;

    if (!this.state.loaded) {
      return <LoadingProgress />;
    }

    const selectedCustomer = formValues ? formValues.Customer : '';
    const filteredMachines = Array.isArray(machines)
      ? machines.filter(m => !selectedCustomer || (m.Customer && m.Customer._id === selectedCustomer))
      : [];

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className={`lqty-filter-grid${role !== 'ADMIN' ? ' no-customer' : ''}`}>
          {role === 'ADMIN' && (
            <div className="lqty-filter-group">
              <Field name="Customer" component={renderSelectField} label="Cliente">
                <option value="">Todos</option>
                {customers
                  .filter(c => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO')
                  .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                  .map(c => (
                    <option value={c._id} key={c._id}>{c.Fullname}</option>
                  ))}
              </Field>
            </div>
          )}
          <div className="lqty-filter-group">
            <Field
              name="Machine"
              component={renderSelectField}
              label="Máquina"
              disabled={role === 'ADMIN' && !selectedCustomer}
            >
              <option value="">Todas</option>
              {filteredMachines.map(machine => (
                <option value={machine._id} key={machine._id}>
                  {machine.Serial}{role === 'ADMIN' ? ` - ${machine.Customer?.Fullname || 'Sin cliente'}` : ''}
                </option>
              ))}
            </Field>
          </div>
          <div className="lqty-filter-group">
            <Field name="Year" component={renderSelectField} label="Año">
              {[...Array(10)].map((_, i) => {
                const year = new Date().getFullYear() - i;
                return <option key={year} value={year}>{year}</option>;
              })}
            </Field>
          </div>
          <div className="lqty-filter-group lqty-filter-action">
            <button type="submit" className="lqty-filter-submit" disabled={submitting}>
              <i className="fas fa-sync"></i>Cargar
            </button>
          </div>
        </div>
        {error && <div className="alert alert-danger mt-2">{error}</div>}
      </form>
    );
  }
}

LockerQtyFilterForm = reduxForm({
  form: 'LockerQtyFilterForm'
})(LockerQtyFilterForm);

const selector = formValueSelector('LockerQtyFilterForm');

const mapStateToProps = state => ({
  customers: state.customers.customers,
  machines: state.machines.machines,
  role: state.auth.role,
  customerId: state.auth.id,
  initialValues: {
    Customer: '',
    Year: new Date().getFullYear().toString()
  },
  formValues: {
    Customer: selector(state, 'Customer'),
    Year: selector(state, 'Year')
  }
});

const mapDispatchToProps = dispatch => ({
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchLockerQty: bindActionCreators(fetchLockerQty, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerQtyFilterForm);
